import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet";
function Sitefaq() {
  const faqData = [
    {
      question: "What is on-page SEO and why is it important?",
      answer:
        "The SEO search engine on the site is the process of customizing the individual pages of your site to rank high in the engine. This involves improving materials, metacoders, internal coupling and site structure. By using the best SEO tool in the form of Seobix helps you automate and limit the strategies in the situation, make sure your page is fully adapted to attract both users and search engines.",
    },
    {
      question: "How does Google Search Console help improve SEO?",
      answer:
        "Google Search Console provides valuable insight into how your site performs in search results. When combined with advanced Sebics analysis, you get even deeper data to fix the performance of your site. This is why many companies depend on Sedes as the best SEO company to decode technical SEOs and promote their visibility.",
    },
    {
      question: "What is keyword research and how can Seobix help?",
      answer:
        "Keyword research involves finding the right keywords using the audience. Seobix's underlying keyword tools help you search for highly affected keywords to rank. If you are looking for the best digital marketing company to provide power to your content strategy, Seobix Smart Keywords is your all-in-one solution for targeting.",
    },
    {
        question:"What is a SERP Simulator and how can it improve click-through rates?",
        answer:"A SERP Simulator shows how your page title and meta description will appear in Google’s search results. This helps you to optimize your snippets for higher click-through rates. Seobix’s built-in SERP Simulator is part of our best SEO services toolkit—so you can preview, tweak, and publish SEO-friendly content that actually gets clicked.",
    },
    {
        question:"Why is domain authority important and how does Seobix check it?",
        answer:"Domain Authority (DA) is a score that predicts how well a website will rank on search engines. A higher DA means better chances of ranking at the top. Seobix includes a free Domain Authority Checker, helping brands monitor and improve their DA using reliable metrics. That’s why businesses trust us as the best social media management company that also understands SEO at its core.",
    }
  ];
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
  return (
    <section className="mb-md-5 mb-2 m-md-0 m-2">
       <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <h2 className="text-center mb-5">Clearing Up the Confusion</h2>

      <Accordion className="" defaultActiveKey="0" style={{marginTop:"4rem"}}>
        {faqData.map((item, index) => (
          <div className="mb-3" key={index}>
            <Accordion.Item eventKey={String(index)} >
              <Accordion.Header>{item.question}</Accordion.Header>
              <Accordion.Body>
                <p>{item.answer}</p>
              </Accordion.Body>
            </Accordion.Item>
          </div>
        ))}
      </Accordion>
    </section>
  );
}

export default Sitefaq;
